module.exports = __webpack_public_path__ + "img/download.4596c593.svg";